// extracted by mini-css-extract-plugin
export default {"AnimatedTab":"AnimatedTab__AnimatedTab___QpLAq","container":"AnimatedTab__container___MC9s2"};